import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import App from "./App.tsx";
// The font the stylesheet has always asked for, finally shipped with the
// site. Nothing loaded it before — no <link>, no @font-face — so every
// visitor without Inter already installed read the whole site in whatever
// system-ui resolved to, and the review cards, which are pictures rendered
// in a browser, were baked in a different fallback again. Self-hosted rather
// than fetched from Google because the CSP allows fonts from 'self' only.
// Three weights: body, semibold, and the headings.
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";
// Handwritten accent notes on the marketing pages ("Better traders...").
import "@fontsource/caveat/latin-600.css";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
